import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { ChavePermissao, PermissaoValidarRequest, PermissaoValidarResponse } from '@/core/api/sicom-api/portal/permissao/permissao.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class PermissaoService extends BaseService {
    readonly PATH = SICOM_PATHS.portal.permissao.validar;

    private readonly _cache = new Map<string, Observable<boolean>>();

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    validar(request: PermissaoValidarRequest, context?: HttpContext): Observable<PermissaoValidarResponse> {
        return this.http.post<PermissaoValidarResponse>(this.PATH, request, { context });
    }

    verificar(chave: ChavePermissao, valor: string): Observable<boolean> {
        const key = `${chave}:${valor}`;
        if (this._cache.has(key)) {
            return this._cache.get(key)!;
        }
        const result$ = this.validar({ validacoes: { [chave]: valor } }).pipe(
            map((response) => response.validacoes[chave] ?? false),
            shareReplay(1)
        );
        this._cache.set(key, result$);
        return result$;
    }

    limparCache(): void {
        this._cache.clear();
    }
}
